import React from 'react';
import PropTypes from 'prop-types';
import './ErrorText.scss';

const ErrorText = ({ cssClass, message }) => {
  return message?.map((msg, i) => {
    const { value, isDisplayed } = msg;
    const errorClassName = cssClass;

    if (!isDisplayed) {
      return null;
    }

    return (
      <span
        /* eslint-disable-next-line react/no-array-index-key */
        key={`${cssClass}_${i}`}
        role="alert"
        aria-live="assertive"
        className={errorClassName}
      >
        <span className="message">
          <i
            className="icon icon-error"
            role="presentation"
            aria-hidden="true"
          />
          <span className="error">{value}</span>
        </span>
      </span>
    );
  });
};

ErrorText.propTypes = {
  cssClass: PropTypes.string,
  message: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node,
      isDisplayed: PropTypes.bool
    })
  ).isRequired
};

export default ErrorText;
